/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-29 14:18:55
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-15 14:28:19
 * @FilePath: /privacy-web/src/store/modules/mobile.js
 */
const state = { isMobile: false, htmlSize: 0 };
const mutations = {
  SETMOBILE: (state, bool) => {
    state.isMobile = bool;
  },
  SETHTMLSIZE: (state) => {
    state.htmlSize = parseFloat(document.getElementsByTagName('html')[0].style.fontSize)
  }
};
const actions = {
  checkMobile({ commit }) {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    // let flag = document.documentElement.clientWidth <= 820
    document.documentElement.style.minWidth = flag ? 'none' : '820px'
    commit('SETMOBILE', flag ? true : false)
    commit('SETHTMLSIZE')
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
